import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { SiteService } from "../../services/site.service";
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { DxDataGridComponent, DxDataGridModule, DxValidationSummaryModule, DxValidationGroupModule } from 'devextreme-angular';
import DataSource from 'devextreme/data/data_source';
import { ProdVolHistory } from "../../types/ProdVolHistory";
import { ProspectListItem } from 'src/app/equipments/services/equipment.service';
import { Production } from '../../types/Production';
import { ProductionVolumeUom } from '../../types/ProductionVolumeUom';

@Component({
  selector: 'app-editvolume',
  templateUrl: './editvolume.component.html',
  styleUrls: ['./editvolume.component.scss']
})
export class EditVolumeComponent implements OnInit, OnChanges {

  @Input() buttonTrigger: boolean;
  @Input() siteId: number;
  @Input() ProductionData: Production;
  @Output() setVolumePopupVisibility: EventEmitter<boolean> = new EventEmitter();
  @Output() setGasFlagForGeoCalcuation: EventEmitter<boolean> = new EventEmitter();
  @Output() setProdVolHistoryData: EventEmitter<ProdVolHistory[]> = new EventEmitter();
  @Output() setProductionData: EventEmitter<Production> = new EventEmitter();
  volumePopupVisible: boolean;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  @ViewChild('popupContent', { static: false }) popupContent: ElementRef;
  dataSource: ProdVolHistory[] = [];
  originalProdVolHistories: ProdVolHistory[] = [];
  isNewEntryClicked: boolean = false;
  isLoadPanelVisible: boolean = false;
  isNewProdVolEntryAdded: boolean = false;
  isSourceTypeVisible: boolean = false;
  gasFlagForGeoCalcuation: boolean = false;
  isSaveCloseClicked: boolean = false;
  isLHe: boolean = false;
  productDataSource: DataSource<any, any>;
  NewProdEntry: ProdVolHistory;
  ProductUnitsDataSource: DataSource<any, any>;
  ReasonsDataSource: DataSource<any, any>;
  SourceTypeDataSource: ProspectListItem[];
  prodVolUomlist: ProductionVolumeUom[];

  constructor(private siteSvc: SiteService,
    private notificationService: NotificationService) { }

  ngOnInit(): void {
    if (this.siteId !== undefined && this.siteId !== -1 && this.siteId !== null) {
      this.getVolumesForSiteId(this.siteId);
    }
    this.GetAllGasProducts();
    this.GetPlantUnits();
    this.GetAllReasons();
    this.GetAllSourceOfGasList();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['buttonTrigger'] && changes['buttonTrigger']?.previousValue != changes['buttonTrigger']?.currentValue) {
      this.volumePopupVisible = changes['buttonTrigger']?.currentValue;
      if (this.volumePopupVisible)
        this.dataSource = Object.assign([], this.originalProdVolHistories);

      this.NewProdEntry = new ProdVolHistory(this.siteId);
    }
  }

  getVolumesForSiteId(siteId) {
    this.siteSvc.getVolumesForSiteId(siteId).subscribe({
      next: data => {
        this.originalProdVolHistories = data;
        this.dataSource = data;
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching Volumes for Site ID : " + siteId, error);
      }
    });
  }

  GetAllGasProducts() {
    this.siteSvc.GetAllGasProducts().subscribe({
      next: data => {
        this.productDataSource = new DataSource({
          store: {
            data: data.filter(x => x.name.toLowerCase() !== ('co2')),
            type: 'array',
            key: 'name',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching gas products list", error);
      }
    })
  }

  GetAllSourceOfGasList() {
    this.siteSvc.GetSupplyTypes().subscribe({
      next: data => {
        this.SourceTypeDataSource = data;
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching source types details", error);
      }
    });
  }

  GetPlantUnits() {
    this.siteSvc.GetAllProdVolUOMList().subscribe({
      next: data => {
        this.prodVolUomlist = data;
        this.ProductUnitsDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'name',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching plant modes", error);
      }
    });
  }

  onValueChanged(e) {
    if (e.value === 'LCO2' || e.value === 'CO2') {
      this.isSourceTypeVisible = true;
    } else {
      this.isSourceTypeVisible = false;
    }

    if (e.value === 'LCO2' || e.value === 'CO2' || e.value === 'LIN+LOX' || e.value === 'LIN-only') {
      this.gasFlagForGeoCalcuation = true;
    }
  }

 ConvertToMTD(vol): number {
    let factor = this.prodVolUomlist.filter(x => x.name == "shortTPD")[0].multiplierToGetMtd;
    var sUnit = Number(vol * Number(factor));
    return Math.round(sUnit);
  }

  Setproductiondata(ProdVolHistories: ProdVolHistory[]) {
    ProdVolHistories.forEach(element => {
      let volumeTPD = element.volume;
      if (element.prodVolUom == "shortTPD") {
        volumeTPD = this.ConvertToMTD(element.volume)
      }
      if (element.prodGas == "LCO2") {
        this.ProductionData.co2flag = true;
        this.ProductionData.co2volumeTpd = volumeTPD;
      }
      if (element.prodGas == "CO2") {
        this.ProductionData.gcO2Flag = true;
        this.ProductionData.gcO2VolumeTPD = volumeTPD;
      }
      if (element.prodGas == "LAR") {
        this.ProductionData.larflag = true;
        this.ProductionData.larTpd = volumeTPD;
      }
      if (element.prodGas == "BHy") {
        this.ProductionData.bhyflag = true;
        this.ProductionData.bhyKnm3h = volumeTPD;
      }
      if (element.prodGas == "LHy") {
        this.ProductionData.lhyflag = true;
        this.ProductionData.lhyvolumeTpd = volumeTPD;
      }
      if (element.prodGas == "LIN+LOX") {
        this.ProductionData.linflag = true;
        this.ProductionData.loxflag = true;
        this.ProductionData.capacity = volumeTPD;
      }
      if (element.prodGas == "LIN-only") {
        this.ProductionData.linflag = true;
        this.ProductionData.capacity = volumeTPD;
      }
      if (element.prodGas == "LUX") {
        this.ProductionData.luX_Flag = true;
        this.ProductionData.luX_TPD = volumeTPD;
      }
    });

  }

  OnDoneClicked() {
    this.isNewProdVolEntryAdded = true;
    this.dataSource.push({ ...this.NewProdEntry });
  }

  GetAllReasons() {
    this.siteSvc.GetAllReasons().subscribe({
      next: data => {
        this.ReasonsDataSource = new DataSource({
          store: {
            data: data,
            type: 'array',
            key: 'reason',
          },
        });
      }, error: (error) => {
        this.notificationService.alert("error", "Error while fetching reasons", error);
      }
    });
  }

  addNewEntry() {
    this.isNewEntryClicked = true;
  }

  OnCancelclicked() {
    this.NewProdEntry = new ProdVolHistory(this.siteId);
    this.isNewEntryClicked = false;
  }

  OnDiscardCloseClicked() {
    this.isNewEntryClicked = false;
    this.isLoadPanelVisible = false;
    this.dataSource = Object.assign([], this.originalProdVolHistories);
    this.setVolumePopupVisibility.emit(false);
  }

  OnSaveCloseClicked() {
    this.OnSaveClicked();
    this.isNewEntryClicked = false;
  }

  setIsClose(isClose) {
    this.isSaveCloseClicked = isClose;
  }

  OnSaveClicked() {
    this.originalProdVolHistories = Object.assign([], this.dataSource);
    this.Setproductiondata(this.originalProdVolHistories);
    this.setProductionData.emit(this.ProductionData);
    this.setProdVolHistoryData.emit(this.dataSource);
    this.setVolumePopupVisibility.emit(false);
    if (this.gasFlagForGeoCalcuation === true) {
      this.setGasFlagForGeoCalcuation.emit(true)
    }
    this.notificationService.alert("warning", "Plant Volumes data captured successfully but kindly note it will not be saved until the site information is saved", null);
    this.isLoadPanelVisible = false;
  }

  onPopupWheel(event: WheelEvent) {
    if (this.popupContent) {
      const element = this.popupContent.nativeElement;
      element.scrollTop += event.deltaY;
      event.preventDefault();
    }
  }
}
